
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import toast from 'react-hot-toast';
import "react-datepicker/dist/react-datepicker.css";
import { fileDownloadBlob, usdCurrencyFormat } from '../../../resources/functions'
import { getBranch } from '../../../store/user/selectors'
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { thirdPartyApi } from '../../../resources/hooks/api/thirdPartyApiHook';

interface Props {

}

const QBBSList: React.FC<Props> = () => {
    const urlParams = useParams();
    const { qbFetchBS } = thirdPartyApi();
    const { t } = useTranslation("scenes.thirdparty.quickbook.QBBSList");

    const [glBalanceSheetList, setGlBalanceSheetList] = useState<any[]>([]);
    const [month, setMonth] = useState<number>(0)
    const [year, setYear] = useState<number>(0)
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const branchData = useSelector(getBranch)

    const fetchBalanceSheetList = (year: number, month: number) => {
        const params: any = {
            "page": 1,
            "per_page": 5000,
            year: year,
            month: month,
            branch_id: +branchData['id']
        }

        setIsLoading(true);
        qbFetchBS(params, (message: string, resp: any) => {
            setIsLoading(false);
            if (resp && resp['data'] && resp['data']['data']) {
                setGlBalanceSheetList(resp.data.data);
            } else {
                setGlBalanceSheetList([]);
            }

        }, (message: string, resp: any) => {
            setGlBalanceSheetList([]);
            setIsLoading(false);
            toast.error(message);
        })
    }


    useEffect(() => {
        if (urlParams['month'] && urlParams['year']) {
            setYear(+urlParams['year']);
            setMonth(+urlParams['month']);
            fetchBalanceSheetList(+urlParams['year'], +urlParams['month']);
        }
    }, [urlParams])


    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title pb-3 pt-3">
                    <div className="row align-items-center">
                        <div className="col-sm-6 align-items-center d-flex">
                            <h1 className="h5 font-weight-700 mb-0 d-inline-flex">{t("page.title")}</h1>
                        </div>
                    </div>
                    <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                        <div className="loader"></div>
                    </div>
                </div>
                <div className="executive-dashboard table-design">
                    {
                        glBalanceSheetList.length ? (
                            <div className='row'>
                                <div className="balance-sheet-table-header col-md-12">
                                    <div className="col-md-4"><h2></h2></div>
                                    <div className="col-md-8 text-center">
                                        {/* <h2>Month ending</h2> */}
                                        <h2>{t("table.currentMonth")}</h2>
                                        <h2>
                                            {moment(`${+year}-${month}-01`).endOf('month').format('MM/DD/YYYY')}
                                        </h2></div>
                                </div>
                                <div className="balance-sheet-table-body col-md-12">
                                    {
                                        glBalanceSheetList.map((data, index) => {

                                            const { report_code } = data['report_code'];
                                            const shouldHideRow = ['VP', 'VP/IP', 'IP'].includes(report_code) && !data['total_amount'] ? 'd-none' : '';
                                            if (shouldHideRow == '') {
                                                return (
                                                    <div className={`bs-table-body-row bs-table-body-${data['report_code']} ${shouldHideRow} resize-font`} key={index}>
                                                        <div className="col-md-4">
                                                            <h4 style={['VP', 'VP/IP', 'IP'].includes(data['report_code']) ? { marginLeft: '35px' } : {}}>
                                                                {data['name']}
                                                            </h4>
                                                        </div>
                                                        {
                                                            !['GH', 'SH', 'SSH'].includes(data['report_code']) && (
                                                                <>
                                                                    <div className="col-md-4 d-flex">
                                                                        <div className="col-md-3 text-end">
                                                                            {
                                                                                ['VP', 'VP/IP', 'IP'].includes(data['report_code']) && (
                                                                                    <h4>
                                                                                        {data['total_amount'] >= 0 ? usdCurrencyFormat(data['total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['total_amount']))})`}
                                                                                    </h4>
                                                                                )
                                                                            }
                                                                        </div>
                                                                        <div className="col-md-3 text-end">
                                                                            {
                                                                                data['report_code'] === 'SST' && (
                                                                                    <h4 className={data['report_code'] + '-sum'}>{data['total_amount'] >= 0 ? usdCurrencyFormat(data['total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['total_amount']))})`}</h4>
                                                                                )
                                                                            }
                                                                        </div>
                                                                        <div className="col-md-3 text-end">
                                                                            {
                                                                                data['report_code'] === 'ST' && (
                                                                                    <h4 className={data['report_code'] + '-sum'}>{data['total_amount'] >= 0 ? usdCurrencyFormat(data['total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['total_amount']))})`}</h4>
                                                                                )
                                                                            }
                                                                        </div>
                                                                        <div className="col-md-3 text-end">
                                                                            {
                                                                                data['report_code'] === 'GT' && (
                                                                                    <h4 className={data['report_code'] + '-sum'}>{data['total_amount'] >= 0 ? usdCurrencyFormat(data['total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['total_amount']))})`}</h4>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) ||
                                                            (
                                                                <>
                                                                    <div className="col-md-4 d-flex">
                                                                        <div className="col-md-3">
                                                                            <h4></h4>
                                                                        </div>
                                                                        <div className="col-md-3">
                                                                            <h4></h4>
                                                                        </div>
                                                                        <div className="col-md-3">
                                                                            <h4></h4>
                                                                        </div>
                                                                        <div className="col-md-3">
                                                                            <h4></h4>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        }

                                                    </div>
                                                );
                                            }

                                        })
                                    }
                                </div>
                            </div>
                        ) : (
                            <div className="text-center">
                                <span>{t("table.balanceSheetUnavailable")}</span>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>

    )
}

export default QBBSList;